import type {
  PrepareAttendanceSessionsParams,
  PrepareAttendanceSessionsResponse,
} from '@src/models/interfaces/prepareAttendanceSession.interface';
import { apiCallable } from '@src/util/cloud-functions/apiClient';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

class PrepareAttendanceSessionRepository {
  async prepareAttendanceSessions(
    params: PrepareAttendanceSessionsParams,
  ): Promise<PrepareAttendanceSessionsResponse> {
    const prepareFn = apiCallable<
      PrepareAttendanceSessionsParams,
      PrepareAttendanceSessionsResponse
    >(API_OPERATIONS.PREPARE_ATTENDANCE_SESSIONS);
    const response = await prepareFn(params);
    return response.data;
  }
}

export default PrepareAttendanceSessionRepository;
